// bao migrate skip
import TabPage from "./../../factories/tab-page";
import baoRouter from "./../../services/bao-router";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class ConfigurationItemReminderTicket {
    constructor(public TabPage: TabPage, public Parent) {
        this._subs.push(this.PageIndex.subscribe(() => {
            if (this.Loading() == false) {
                this.Refresh();
            }
        }));
        this._subs.push(this.Sorting.subscribe(() => {
            if (this.Loading() == false) {
                this.Refresh();
            }
        }));
        this._subs.push(this.ShowCompletedReminders.subscribe(() => {
            if (this.Loading() == false) {
                this.PageIndex(0);
                this.Refresh();
            }
        }));
        this.SelectionReminderRows.subscribe((newValue) => this.SelectionChanged(newValue));
    }
    private _subs: KnockoutSubscription[] = [];
    Bao = Bao;
    PageIndex = ko.observable<number>(0);
    PageSize = ko.observable<number>(20);
    TotalRows = ko.observable<number>(0);
    Sorting = ko.observable<any>();
    ReminderCollection = ko.observableArray<any>([]);
    ShowCompletedReminders = ko.observable<boolean>(false);
    Loading = ko.observable<boolean>(false);
    SelectedReminderRow = ko.observable<any>();
    SelectionReminderRows = ko.observableArray<any>([]);
    public SelectionChanged(selectedRows: any[]): JQueryXHR {
        this.EnableDisableButtons(selectedRows);
        if (selectedRows != null && selectedRows.length == 1) {
            this.SelectedReminderRow(selectedRows[0]);
        }
        else {
            this.SelectedReminderRow(null);
        }
        return null;
    }
    EnableDisableButtons(selectedRows: any[]) {
        if (selectedRows != null && selectedRows.length > 0) {
            if (selectedRows.length == 1) {
                this.enableDisableButton("ConfigurationItemReminderTicketEdit", true);
                this.enableDisableButton("ConfigurationItemReminderTicketHistory", true);
            }
            else {
                this.enableDisableButton("ConfigurationItemReminderTicketEdit", false);
                this.enableDisableButton("ConfigurationItemReminderTicketHistory", false);
            }
            this.enableDisableButton("ConfigurationItemReminderTicketDelete", true);
        }
        else {
            this.enableDisableButton("ConfigurationItemReminderTicketEdit", false);
            this.enableDisableButton("ConfigurationItemReminderTicketDelete", false);
            this.enableDisableButton("ConfigurationItemReminderTicketHistory", false);
        }
    }
    enableDisableButton = (ActionKey: string, Enabled: boolean) => { };
    toolbarClick = (item) => {
        switch (item.ActionKey()) {
            case "ConfigurationItemReminderTicketNew":
                this.AddReminder();
                break;
            case "ConfigurationItemReminderTicketEdit":
                this.EditConfigurationItemReminder(this.SelectedReminderRow());
                break;
            case "ConfigurationItemReminderTicketRefresh":
                this.Refresh();
                break;
            case "ConfigurationItemReminderTicketDelete":
                this.DeleteConfigurationItemReminder(this.SelectedReminderRow());
                break;
            case "ConfigurationItemReminderTicketHistory":
                //Open Dialog mit selectedReminderRow.TicketID
                this.OpenHistoryDialog(this.SelectedReminderRow());
                break;
        }
    };

    /**
     * Opens a dialog containing the history of a selected row
     * @param selectedReminderRow
     */
    OpenHistoryDialog(selectedReminderRow) {
        this.TabPage.IsLoading(true);
        Bao.post("ReminderTicket/ReminderTicketHistoryDialog", JSON.stringify({}), ((result) => {
            this.TabPage.IsLoading(false);
            const dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.Template(result);
            dialog.Width("1600px");
            dialog.ViewModel(selectedReminderRow.TicketId);
            dialog.Open();
            dialog.SetPosition();
            dialog.DialogResult.subscribe((dialogResult) => {
                if (dialogResult === true) {
                    dialog.Close();
                }
            });
        }));
    }
    AddReminder = () => {
        //var reminderTicketTab = new TabPages();
        //reminderTicketTab.Url("ReminderTicket");
        //reminderTicketTab.Route = { InitData:  this.Parent.ConfigurationItemId()  };
        //AppTabController.AddTab(reminderTicketTab);
        baoRouter.setHash("#reminderticket/new/" + ko.unwrap(this.Parent.ConfigurationItemId()));
    };
    EditConfigurationItemReminder = (item) => {
        if (item != null) {
            baoRouter.setHash("#reminderticket/" + ko.unwrap(item.PrimaryKeyValue));
        }
    };
    DeleteConfigurationItemReminder = (item) => {
        if (item != null) {
            var questionDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteConfigurationItemReminder"), "yesno");
            questionDialog.DialogResult.subscribe((result) => {
                if (result === true) {
                    this.TabPage.IsLoading(true);
                    Bao.post("ConfigurationItemReminderTicket/Delete", JSON.stringify({
                        ticketId: item.TicketId,
                    }), (result) => {
                        this.TabPage.IsLoading(false);
                        this.Refresh();
                    });
                }
            });
        }
    };
    CompleteCheck() {
        var def = $.Deferred();
        def.resolve(true);
        return def.promise();
    }
    Refresh() {
        this.Loading(true);
        this.TabPage.IsLoading(true);
        return Bao.post("ConfigurationItemReminderTicket/Get", JSON.stringify({
            configurationItemId: this.Parent.ConfigurationItemId(),
            showCompleted: this.ShowCompletedReminders(),
            sorting: this.Sorting(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize()
        }), (result) => {
            this.TabPage.IsLoading(false);
            this.TotalRows(result.TotalRows);
            this.ReminderCollection(result.Models ||[]);
            this.SelectionReminderRows([]);
            this.Loading(false);
        });
    }
    init() {
    }
    loaded() {
        return this.Refresh();
    }
    ;
}
export default ConfigurationItemReminderTicket;